import {find, propEq} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {DashboardTile} from '../types/DashboardTile';
import {DashboardTileDefinition} from '../types/DashboardTileDefinition';
import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {reconcileDashboardGrid} from './reconcileDashboardGrid';

export function selectShownDashboardTiles(
  arrangement: DashboardTilePlacement[],
  definitions: DashboardTileDefinition[],
  visibleIds: DashboardTileId[]
): DashboardTile[] {
  const visibleIdSet = new Set(visibleIds);
  const visiblePlacements = arrangement.filter(
    (placement) =>
      visibleIdSet.has(placement.id) && isNotNil(find(propEq(placement.id, 'id'), definitions))
  );

  return reconcileDashboardGrid(visiblePlacements)
    .map((placement) => {
      const definition = find(propEq(placement.id, 'id'), definitions);

      return isNotNil(definition)
        ? {
            id: placement.id,
            renderer: definition.renderer,
            size: placement.size,
            column: placement.column,
            row: placement.row,
          }
        : null;
    })
    .filter(isNotNil);
}
